module.exports = __webpack_public_path__ + "img/c01_unitspearman_Normal_ua.066accc2.webp";